// extracted by mini-css-extract-plugin
export default {"bar":"styles-module--bar--2hYHT","label":"styles-module--label--2Rzea","subtitle":"styles-module--subtitle--2Qges"};